/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBadges = createReactComponent("outline", "badges", "IconBadges", [["path", { "d": "M17 17v-4l-5 3l-5 -3v4l5 3z", "key": "svg-0" }], ["path", { "d": "M17 8v-4l-5 3l-5 -3v4l5 3z", "key": "svg-1" }]]);

export { IconBadges as default };
//# sourceMappingURL=IconBadges.mjs.map
